import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import Layout from './layout/Layout';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Layout></Layout>
      </div>
    </BrowserRouter>
  );
}

export default App;
